<template>
    <b-modal id="myPrescribeDetailModal" :title="title" size="md">
        <div class="search user_modal">
            <div class="table_list">
                <div class="detail">
                    <div class="title_sm pt0">
                        <h3 class="tb_title">개인방제 상세</h3>
                    </div>
                    <table class="write">
                        <colgroup>
                            <col width="100">
                        </colgroup>
                        <tbody>
                            <tr>
                                <th>처방명</th>
                                <td><span>{{myPrescribeData.prescribe_nm}}</span></td>
                            </tr>
                            <tr>
                                <th>출전</th>
                                <td><span>{{myPrescribeData.prescribe_source}}</span></td>
                            </tr>
                            <tr>
                                <th>카테고리</th>
                                <td><span>{{myPrescribeData.prescribe_category_nm}}</span></td>
                            </tr>
                            <tr>
                                <th>메모</th>
                                <td><span>{{myPrescribeData.prescribe_note}}</span></td>
                            </tr>
                            <tr>
                                <th>처방구성</th>
                                <td><span>{{myPrescribeData.prescribe_medicine}}</span></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <template #modal-footer="{ ok }">
            <b-button @click="fn_click_apply()" class="btn btn_md btn_brown">반영</b-button>
            <b-button @click="ok" class="btn btn_md btn_brown">닫기</b-button>
        </template>
    </b-modal>

</template>

<script>
    export default {
        name: 'myPrescribeDetailModal',
        props: {
            title: String,
            myPrescribeData : {
                prescribe_nm : '',
                prescribe_source : '',
                prescribe_category : '',
                prescribe_category_nm : '',
                prescribe_medicine : '',
                prescribe_note : '',
                item : {}
            }
        },
        methods: {
            fn_click_apply(){
                this.$emit('callback', this.myPrescribeData.item);
            }          
        },
        data () {
            return {
            }
        }
    }
</script>

<style>

</style>